import * as React from 'react';

import {
    Props,
} from 'one-ui';

export interface ValuesProps extends Props {
}

export const Values = ({
    children,
    className,
}: ValuesProps) => (
        <div className={
            (!(className)) ?
                'values' :
                `values ${className}`
        }>
            {children}
        </div>
    );
